<template>
  <div class="">
    <div v-if="!isHorizontal">{{ field.name }}</div>
    <b-form-textarea
      :id="uniqueId"
      @input="onChange"
      :disabled="isFieldDisabled"
      rows="2"
      max-rows="5"
      :maxlength="maxLength"
      v-model="textarea"
    />
    <div class="d-flex flex-column">
      <span class="textHint" v-if="hint">{{ hint }}</span>
      <span class="text-error" v-if="error">{{ error }}</span>
    </div>
  </div>
</template>
<script>
import {ref, onMounted, computed, watch} from "@vue/composition-api";

export default {
  components: {
  },
  props: {
    field: {
      type: Object,
      default: () => ({}),
    },
    isFormDisabled: {
      type: Boolean,
      default: false
    },
    errors: {
      type: Object,
      default: () => ({}),
    },
    isHorizontal: {
      type: Boolean,
      default: true
    }
  },
  setup(props, { emit }) {
    const uniqueId = Date.now().toString(36) + Math.random().toString(36).slice(2);
    const showBtnGroup = ref(false);
    const isFieldDisabled = ref(false);
    const textarea = ref("");
    const hint = ref("");
    const maxLength = ref(4000);
    const error = ref(null);

    watch(
      () => props.errors,
      (newValue, oldValue) => {
        error.value = props.errors[props.field.originalName] || null;
      },
      { immediate: true }
    );

    watch(
      () => props.isFormDisabled,
      (newValue, oldValue) => {
        isFieldDisabled.value = props.isFormDisabled;
      },
      { immediate: true }
    );

    onMounted(async () => {
      hint.value = props?.field?.options?.fieldTypeCfg?.data[0]?.hint;
      isFieldDisabled.value = props.isFormDisabled
      showBtnGroup.value = props?.field?.options?.isGroup;
      maxLength.value = props?.field?.options?.fieldTypeCfg?.data[0]?.maxLength || 4000;
      hint.value =  `${hint.value ?? ""} ${maxLength.value  ? " - Máximo " + maxLength.value + " caracteres." : ""}`
    });

    function onChange() {
      emit("updateData", props.field, textarea.value);
    }

    return {
      uniqueId,
      showBtnGroup,
      isFieldDisabled,
      textarea,
      hint,
      maxLength,
      error,
      onChange,
    }
  }
}
</script>
<style scoped lang="scss">
.text-error {
  color: #ec0303;
}
</style>